import React, {useState, useEffect} from 'react';
import { faArrowCircleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { getJobPosts, getCategoryJobPosts, getJobCount } from '../../utils/api-services/job';
import JobPostItem from './JobPostItem';
import "../../global/components/scroll-bar.css";
import PaginationControl from '../../global/components/PaginationControl';
import PageLoader from '../../global/components/PageLoader';

const JobList = ({category, page}) => {

    const [jobs, setJobs] = useState([]);
    const [jobCount, setJobCount] = useState(null);
    const [url, setUrl] = useState("");
    const [ query, setQuery] = useState("");
    const [loading, setLoading] = useState(false);
    const [width, setWidth] = useState(window.innerWidth);
    const isMobile = width <= 768;

    useEffect(()=>{
        loadJob("");
        loadJobCount();
        updateUrl();
    }, []);

    function postSearch(){
        loadJob(query);
    }

    function loadJob(qry){
        if(category != "" && category != null && category != undefined){
            loadCategoryJobPosts(category, page, qry)
        }else{
            loadJobPosts(page, qry);
        }
    }

    const loadJobPosts = async (page, query) => {
        setLoading(true);
        const data = await getJobPosts(page, query);
        setJobs(data);
        setLoading(false);
    }

    const loadCategoryJobPosts = async (category, page, query) => {
        setLoading(true);
        const data = await getCategoryJobPosts(category, page, query);
        setJobs(data);
        setLoading(false);
    }

    const loadJobCount = async () => {
        if(category != "" && category != null && category != undefined){
            const data = await getJobCount(category);
            setJobCount(data);
        }else{
            const data = await getJobCount("");
            console.log(">>",data)
            setJobCount(data);
        }
    }

    function updateUrl(){
        if(category != "" && category != null && category != undefined){
            setUrl(`/job/list/${category}`);
        }else{
            setUrl(`/job/list`);
        }
    }

    const styles = {
        section:{

        },
        items: {
            
        },
        search: {
            wrap:{
                marginBottom: 20,
            },
            body:{
                width: '100%',
                position: 'relative'
            },
            btn:{
                fontSize: 18,
                position: 'absolute',
                top: 44,
                right: 36
            },
            input:{
                paddingRight: 50,
                borderRadius: 30
            }
        },
        pagination: {
            wrap: {
                display: 'flex'
            },
            controls:{
                marginLeft: 'auto'
            }
        }
    }

    const display = (
        <div style={styles.section}>

            <div style={styles.search.wrap}>
                <Link onClick={()=>postSearch()} style={styles.search.btn}>
                    <FontAwesomeIcon icon={faArrowCircleRight} />
                </Link>
                <div style={styles.search.wrap}>
                    <input type='text' value={query} onChange={e => setQuery(e.target.value)} style={styles.search.input} className="form-control" placeholder="Search Job" />
                </div>
            </div>

            <hr />

            <div style={styles.items}>
                {jobs.map((itm, index) => (
                    <JobPostItem key={index} obj={itm} />
                ))}
            </div>
            
            <div style={styles.pagination.wrap}>
                <div style={styles.pagination.controls}>
                    {jobCount &&
                        <PaginationControl page={page} count={jobCount} url={url} />
                    }
                </div>
            </div>

        </div>
    )

    if(loading){
        return <PageLoader top={50} bottom={50} />
    }else{
        return (jobs.length > 0) && display;
    }
}

export default JobList